import script from "./AllNews.vue?vue&type=script&setup=true&lang=js"
export * from "./AllNews.vue?vue&type=script&setup=true&lang=js"

import "./AllNews.vue?vue&type=style&index=0&id=7775caea&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7775caea"]])

export default __exports__